// generated from 27_218 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const messageEngagementSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("message_engagement_since_filter"),
  comparison_key: z.enum([
    "4", // 20_514 (75.37%)
    "3", // 4_050 (14.88%)
    "6", // 2_051 (7.54%)
    "12", // 507 (1.86%)
    "5", // 96 (0.35%)
  ]),
  display_name: z.enum([
    "opened any email", // 17_127 (62.93%)
    "clicked any email", // 4_728 (17.37%)
    "opened any push", // 3_008 (11.05%)
    "opened any email (other opens)", // 1_305 (4.79%)
    "clicked any shortened sms link", // 612 (2.25%)
    "clicked any in-app message", // 236 (0.87%)
    "opened any email (machine opens)", // 184 (0.68%)
    "read any WhatsApp message", // 17 (0.06%)
    "clicked any tracked WhatsApp link", // 1 (0.00%)
  ]),
  // undefined: 15_456 (56.79%), defined 11_762 (43.21%)
  raw_value: z
    .union([
      // number samples: 8_884 (75.53%)
      // integer: 8_521 (95.91%)
      // avg: 158.58, min: 0, max: 3640
      z.number().min(0),
      // string samples: 2_878 (24.47%)
      // format date: 2_869 (99.69%)
      z.string(),
    ])
    .optional(),
  value: z.union([
    // number samples: 22_591 (83.00%)
    // integer: 22_100 (97.83%)
    // avg: 182.65, min: 0, max: 3640
    z.number().min(0),
    // string samples: 4_627 (17.00%)
    // format date: 4_612 (99.68%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(false),
});
